import React from "react";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

interface IProps {
  anchorEl: null | HTMLElement;
  open: boolean;
  handleClose: Function;
  handleDelete: Function;
}

const TypeContextMenu: React.FC<IProps> = ({
  anchorEl,
  open,
  handleClose,
  handleDelete
}) => {
  return (
    <Menu
      id="long-menu"
      anchorEl={anchorEl}
      keepMounted
      open={open}
      onClose={() => handleClose()}
    >
      <MenuItem onClick={() => handleDelete(true)}>Desativar</MenuItem>
    </Menu>
  );
};

export default TypeContextMenu;
